'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diffusionProviderFactory;

var _diffusion = require('diffusion');

var diffusion = _interopRequireWildcard(_diffusion);

var _subscription = require('../utils/subscription');

var _subscription2 = _interopRequireDefault(_subscription);

var _domConfigurationStrategy = require('./domConfigurationStrategy');

var _domConfigurationStrategy2 = _interopRequireDefault(_domConfigurationStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function sessionWrapper(session) {
    return {

        stream: function stream(topic) {
            var diffusionSubscription = session.addStream(topic, diffusion.datatypes.recordv2())
            // eslint-disable-next-line no-unused-vars
            .on('value', function (topicString, specification, newValue, oldValue) {
                // eslint-disable-next-line no-use-before-define
                subscr.onUpdate(newValue.asRecords(), topicString);
            });

            var subscr = (0, _subscription2.default)();
            subscr.subscribe(diffusionSubscription);

            return subscr;
        },
        subscribe: function subscribe(topic) {
            var initCallback = void 0;
            var events = {
                on: function on(eventType, callback) {
                    initCallback = callback;
                }
            };
            session.select(topic).then(function () {
                initCallback(topic, true);
            });
            return events;
        },
        unsubscribe: session.unsubscribe,
        on: session.on.bind(session),
        off: session.off.bind(session),
        close: session.close.bind(session)
    };
}

function diffusionProviderFactory() {
    function provider() {
        var configurationStrategy = (0, _domConfigurationStrategy2.default)();
        return diffusion.connect(configurationStrategy.getConfig()).then(sessionWrapper);
    }
    return {
        provider: provider,
        log: function log(level) {
            return diffusion.log(level);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/diffusion.js
// module id = 2144
// module chunks = 1